import _defineProperty from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
import classNames from 'classnames';
import { generateIntArray } from '../../utils/generate-int-array';
import { mergeProps } from '../../utils/with-default-props';
var classPrefix = 'adm-skeleton';
export var Skeleton = function Skeleton(props) {
  return withNativeProps(props, React.createElement("div", {
    className: classNames(classPrefix, _defineProperty({}, "".concat(classPrefix, "-animated"), props.animated))
  }));
};
export var SkeletonTitle = function SkeletonTitle(props) {
  return withNativeProps(props, React.createElement(Skeleton, {
    animated: props.animated,
    className: "".concat(classPrefix, "-title")
  }));
};
var defaultSkeletonParagraphProps = {
  lineCount: 3
};
export var SkeletonParagraph = function SkeletonParagraph(p) {
  var props = mergeProps(defaultSkeletonParagraphProps, p);
  var keys = generateIntArray(1, props.lineCount);
  var node = React.createElement("div", {
    className: "".concat(classPrefix, "-paragraph")
  }, keys.map(function (key) {
    return React.createElement(Skeleton, {
      key: key,
      animated: props.animated,
      className: "".concat(classPrefix, "-paragraph-line")
    });
  }));
  return withNativeProps(props, node);
};